import { render } from "./mar.vue?vue&type=template&id=7f94afca"
const script = {}

import "./mar.vue?vue&type=style&index=0&id=7f94afca&lang=scss"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__